<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          Offer Letter</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <validation-observer
      v-show="!showTemplate"
      ref="simpleRules"
    >
      <b-form class="ex-large">
        <app-timeline>
          <app-timeline-item class="pb-1">
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>First Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="First Name"
                    rules="required"
                  >
                    <b-form-input
                      id="first_name"
                      v-model="addOL.first_name"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Last Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Last Name"
                    rules="required"
                  >
                    <b-form-input
                      id="last_name"
                      v-model="addOL.last_name"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Contact Email</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Contact Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="addOL.email"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Address</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Address"
                    rules="required"
                  >
                    <b-form-input
                      id="address"
                      v-model="addOL.address"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Role</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Role"
                    rules="required"
                  >
                    <b-form-input
                      id="role"
                      v-model="addOL.role"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Start Date</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Start Date"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="start_date"
                      class="form-control"
                      :config="$store.state.config"
                      placeholder="MM-DD-YYYY"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>
        </app-timeline>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="updateContent"
            >
              Update Content
            </b-button>
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="generatePdf"
            >
              Generate Pdf
            </b-button>
            <b-button
              variant="primary"
              type="button"
              @click="sentForSign"
            >
              Send for E-Sign
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
    <b-modal
      ref="validFor"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      size="sm"
      centered
      title="Valid For"
    >
      <validation-observer
        ref="valid_form"
        tag="form"
      >
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Valid For</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="Valid For"
                  rules="required|integer|between:1,11"
                >
                  <b-form-input
                    v-model="addOL.valid_for"
                    placeholder="Valid For"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <b-button
            variant="outline-primary"
            class="px-1"
            @click="closeValidFor()"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="ml-1 px-1"
            @click="sendForSignature()"
          >
            Send
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="updateContentValidFor"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      size="sm"
      centered
      title="Valid For"
    >
      <validation-observer
        ref="update_valid_form"
        tag="form"
      >
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Valid For</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="Valid For"
                  rules="required|integer|between:1,11"
                >
                  <b-form-input
                    v-model="template.valid_for"
                    placeholder="Valid For"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <b-button
            variant="outline-primary"
            class="px-1"
            @click="closeUpdateValidFor()"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="ml-1 px-1"
            @click="sendForUpdateContentSignature()"
          >
            Send
          </b-button>
        </div>
      </template>
    </b-modal>
    <validation-observer
      v-show="showTemplate"
      ref="templateRules"
    >
      <b-form class="ex-large">
        <b-row>
          <b-col
            cols="12"
            md="10 ml-auto mr-auto"
          >
            <b-form-group>
              <div
                class="msa-form"
              >
                <div class="text-right mb-4">
                  <b-img
                    fluid
                    :src="template.logo"
                    alt="Company Logo"
                  />
                </div>
                <p
                  id="template_content"
                  v-html="template.template_response"
                />
                <div class="content-footer">
                  <b-row>
                    <b-col cols="6">
                      <p>Sincerely,</p>
                      <div class="mt-2 mb-50">
                        ________________________________
                        <span class="small d-block">(Signature)</span>
                      </div>
                      <p class="mb-0">{{ template.company_user_name }}</p>
                      <p class="mb-0">{{ template.company_user_title }}</p>
                      <div class="address-width-250">
                        <p>{{ template.company_address }}</p>
                      </div>
                      <p class="mt-2">
                        Employee Signature: {{ template.name }}</p>
                      <div class="mt-2 mb-50">
                        ________________________________
                        <span class="small d-block">(Signature)</span>
                      </div>
                      <p>Printed Name: {{ template.first_name }} {{ template.last_name }}</p>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="back"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="generatePdfWithUpdatedContent"
            >
              Generate Pdf
            </b-button>
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="sendForESignWithUpdatedContent"
            >
              Send for E-Sign
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BForm, BModal, BFormGroup, BFormInput, BImg, BButton,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import {
  required,
} from '@validations'
import OfferLetter from '@/js/offerletter'
import Constants from '@/js/constant'

export default {
  name: 'EmployeeOfferLetter',
  components: {
    BCard,
    BModal,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BButton,
    flatPickr,
    // currency,
  },
  directives: {
    Ripple,
  },
  setup() {
  },
  data() {
    return {
      required,
      addOL: {
        title: '',
        email: '',
        contact_name: '',
        address: '',
        state: '',
        valid_for: 5,
      },
      start_date: null,
      showTemplate: false,
      updateMsa: {
        template_response: '',
      },
      template: {
        template_response: '',
        logo: '',
        name: '',
        title: '',
        email: '',
        valid_for: 5,
      },
      date: null,
      formstate: {},
      submitted: false,
    }
  },
  watch: {
  },
  mounted() {
  },
  created() {
    OfferLetter.getEmployeeOfferLetterById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    sendForSignature() {
      this.$refs.valid_form.validate().then(result => {
        if (result) {
          if (this.start_date != null) {
            this.addOL.start_date = Constants.getEprmMonthDateFromString(
              this.start_date,
            )
          }
          this.showLoading = true
          OfferLetter.sendEmployeeOfferLetterForSign(this, this.$route.params.id, this.addOL)
        }
      })
    },
    sentForSign() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          this.$refs.validFor.show()
        }
      })
    },
    closeValidFor() {
      this.$refs.validFor.hide()
    },
    generatePdf() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          if (this.start_date != null) {
            this.addOL.start_date = Constants.getEprmMonthDateFromString(
              this.start_date,
            )
          }
          this.showLoading = true
          OfferLetter.getEmployeeOfferLetterPdfById(this, this.$route.params.id, this.addOL)
        }
      })
    },
    updateContent() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          if (this.start_date != null) {
            this.addOL.start_date = Constants.getEprmMonthDateFromString(
              this.start_date,
            )
          }
          this.showLoading = true
          OfferLetter.getEmployeeOfferLetterTemplateById(this, this.$route.params.id, this.addOL)
        }
      })
    },
    generatePdfWithUpdatedContent() {
      this.$refs.templateRules.validate().then(result => {
        if (result) {
          if (this.start_date != null) {
            this.template.start_date = Constants.getEprmMonthDateFromString(
              this.start_date,
            )
          }
          this.template.template_response = document.getElementById('template_content').innerHTML.replaceAll('\n', '')
          this.showLoading = true
          OfferLetter.getEmployeeOfferLetterPdfByIdAndUpdatedContent(this, this.$route.params.id, this.template)
        }
      })
    },
    closeUpdateValidFor() {
      this.$refs.updateContentValidFor.hide()
    },
    sendForUpdateContentSignature() {
      this.$refs.update_valid_form.validate().then(result => {
        if (result) {
          if (this.start_date != null) {
            this.template.start_date = Constants.getEprmMonthDateFromString(
              this.start_date,
            )
          }
          this.template.template_response = document.getElementById('template_content').innerHTML.replaceAll('\n', '')
          this.showLoading = true
          OfferLetter.sendEmployeeOfferLetterUpdatedContentForSign(this, this.$route.params.id, this.template)
        }
      })
    },
    sendForESignWithUpdatedContent() {
      this.$refs.templateRules.validate().then(result => {
        if (result) {
          this.template.template_response = document.getElementById('template_content').innerHTML.replaceAll('\n', '')
          this.$refs.updateContentValidFor.show()
        }
      })
    },
    setEmployeeDetails(employeeDetails) {
      this.addOL = employeeDetails
      this.addOL.valid_for = 5
      this.start_date = employeeDetails.start_date
    },
    pdfPath(data) {
      window.open(data.pdf_path, '_blank')
      this.back()
    },
    employeeLetterTemplate(data) {
      this.showTemplate = true
      this.template = data
      this.template.valid_for = 5
    },
    pdfNotFound(message) {
      this.$swal({
        icon: 'warning',
        title: 'Offer Letter!',
        text: message,
      })
    },
    sentSuccess(data) {
      this.$refs.showLoading = false
      this.back()
      this.$swal({
        title: 'Success!',
        text: data.return_message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    sentFailure(message) {
      this.$refs.showLoading = false
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
